import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { ServiceOfferListRepository } from './domain'

import { ListCriteria, ServiceOfferListView } from '../../contracts/service-offer'
import { AxiosErrorHandler, SupernovaPagedBody } from '../../foundation'

export class PartnerApiServiceOfferListRepository implements ServiceOfferListRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getList = async (criteria: ListCriteria): Promise<SupernovaPagedBody<ServiceOfferListView[]>> => {
    const defaultSort: ListCriteria['sort'] = { orders: [{ fieldName: 'id', direction: 'DESC' }] }
    const isSortNotDefined = !criteria.sort || criteria.sort?.orders?.length === 0

    const config: AxiosRequestConfig<ListCriteria> = {
      url: '/service-offer/query/partner/service-offer-list/process',
      method: 'post',
      data: {
        ...criteria,
        sort: isSortNotDefined ? defaultSort : criteria.sort,
      },
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedBody<ServiceOfferListView[]>>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
